import m from "./index244.mjs";
import I from "./index245.mjs";
import k from "./index246.mjs";
import Y from "./index247.mjs";
import W from "./index248.mjs";
import f from "./index249.mjs";
import M from "./index250.mjs";
import w from "./index251.mjs";
import A from "./index252.mjs";
import H from "./index253.mjs";
import E from "./index254.mjs";
import B from "./index255.mjs";
import x from "./index256.mjs";
import F from "./index257.mjs";
import N from "./index258.mjs";
import b from "./index259.mjs";
import q from "./index260.mjs";
import g from "./index261.mjs";
import u from "./index262.mjs";
import d from "./index263.mjs";
import V from "./index226.mjs";
import R from "./index264.mjs";
import T from "./index265.mjs";
import j from "./index266.mjs";
import L from "./index267.mjs";
import Q from "./index268.mjs";
import U from "./index269.mjs";
import z from "./index270.mjs";
import C from "./index271.mjs";
import G from "./index272.mjs";
import l from "./index236.mjs";
import n from "./index235.mjs";
import J from "./index233.mjs";
import K from "./index273.mjs";
import P from "./index274.mjs";
import X from "./index275.mjs";
import Z from "./index276.mjs";
import _ from "./index168.mjs";
import $ from "./index167.mjs";
import v from "./index277.mjs";
import tt from "./index278.mjs";
import rt from "./index279.mjs";
import et from "./index280.mjs";
import st from "./index281.mjs";
import ot from "./index282.mjs";
import it from "./index283.mjs";
import D from "./index234.mjs";
import y from "./index284.mjs";
import S from "./index285.mjs";
import p from "./index286.mjs";
import a from "./index287.mjs";
import nt from "./index288.mjs";
import at from "./index289.mjs";
import ht from "./index290.mjs";
import mt from "./index203.mjs";
import ft from "./index291.mjs";
import { AdapterDateFnsBase as ut } from "./AdapterDateFnsBase.mjs";
class Mr extends ut {
  constructor({
    locale: c,
    formats: O
  } = {}) {
    if (typeof m != "function")
      throw new Error(["MUI: The `date-fns` package v3.x is not compatible with this adapter.", "Please, install v2.x of the package or use the `AdapterDateFnsV3` instead."].join(`
`));
    super({
      locale: c ?? mt,
      formats: O,
      longFormatters: ft
    }), this.parseISO = (t) => nt(t), this.toISO = (t) => at(t, {
      format: "extended"
    }), this.parse = (t, r) => t === "" ? null : $(t, r, /* @__PURE__ */ new Date(), {
      locale: this.locale
    }), this.isValid = (t) => _(this.date(t)), this.format = (t, r) => this.formatByString(t, this.formats[r]), this.formatByString = (t, r) => V(t, r, {
      locale: this.locale
    }), this.getDiff = (t, r, e) => {
      switch (e) {
        case "years":
          return w(t, this.date(r));
        case "quarters":
          return A(t, this.date(r));
        case "months":
          return H(t, this.date(r));
        case "weeks":
          return E(t, this.date(r));
        case "days":
          return B(t, this.date(r));
        case "hours":
          return x(t, this.date(r));
        case "minutes":
          return F(t, this.date(r));
        case "seconds":
          return N(t, this.date(r));
        default:
          return b(t, this.date(r));
      }
    }, this.isEqual = (t, r) => t === null && r === null ? !0 : J(t, r), this.isSameYear = (t, r) => P(t, r), this.isSameMonth = (t, r) => X(t, r), this.isSameDay = (t, r) => K(t, r), this.isSameHour = (t, r) => Z(t, r), this.isAfter = (t, r) => l(t, r), this.isAfterYear = (t, r) => l(t, d(r)), this.isAfterDay = (t, r) => l(t, g(r)), this.isBefore = (t, r) => n(t, r), this.isBeforeYear = (t, r) => n(t, a(r)), this.isBeforeDay = (t, r) => n(t, D(r)), this.isWithinRange = (t, [r, e]) => ht(t, {
      start: r,
      end: e
    }), this.startOfYear = (t) => a(t), this.startOfMonth = (t) => y(t), this.startOfWeek = (t) => p(t, {
      locale: this.locale
    }), this.startOfDay = (t) => D(t), this.endOfYear = (t) => d(t), this.endOfMonth = (t) => S(t), this.endOfWeek = (t) => u(t, {
      locale: this.locale
    }), this.endOfDay = (t) => g(t), this.addYears = (t, r) => M(t, r), this.addMonths = (t, r) => f(t, r), this.addWeeks = (t, r) => W(t, r), this.addDays = (t, r) => m(t, r), this.addHours = (t, r) => Y(t, r), this.addMinutes = (t, r) => k(t, r), this.addSeconds = (t, r) => I(t, r), this.getYear = (t) => G(t), this.getMonth = (t) => Q(t), this.getDate = (t) => R(t), this.getHours = (t) => j(t), this.getMinutes = (t) => L(t), this.getSeconds = (t) => U(t), this.getMilliseconds = (t) => z(t), this.setYear = (t, r) => it(t, r), this.setMonth = (t, r) => et(t, r), this.setDate = (t, r) => v(t, r), this.setHours = (t, r) => tt(t, r), this.setMinutes = (t, r) => rt(t, r), this.setSeconds = (t, r) => st(t, r), this.setMilliseconds = (t, r) => ot(t, r), this.getDaysInMonth = (t) => T(t), this.getNextMonth = (t) => f(t, 1), this.getPreviousMonth = (t) => f(t, -1), this.getMonthArray = (t) => {
      const e = [a(t)];
      for (; e.length < 12; ) {
        const i = e[e.length - 1];
        e.push(this.getNextMonth(i));
      }
      return e;
    }, this.mergeDateAndTime = (t, r) => this.setSeconds(this.setMinutes(this.setHours(t, this.getHours(r)), this.getMinutes(r)), this.getSeconds(r)), this.getWeekdays = () => {
      const t = /* @__PURE__ */ new Date();
      return q({
        start: p(t, {
          locale: this.locale
        }),
        end: u(t, {
          locale: this.locale
        })
      }).map((r) => this.formatByString(r, "EEEEEE"));
    }, this.getWeekArray = (t) => {
      const r = p(y(t), {
        locale: this.locale
      }), e = u(S(t), {
        locale: this.locale
      });
      let i = 0, o = r;
      const s = [];
      for (; n(o, e); ) {
        const h = Math.floor(i / 7);
        s[h] = s[h] || [], s[h].push(o), o = m(o, 1), i += 1;
      }
      return s;
    }, this.getWeekNumber = (t) => C(t, {
      locale: this.locale
    }), this.getYearRange = (t, r) => {
      const e = a(t), i = d(r), o = [];
      let s = e;
      for (; n(s, i); )
        o.push(s), s = M(s, 1);
      return o;
    };
  }
}
export {
  Mr as AdapterDateFns
};
//# sourceMappingURL=AdapterDateFns.mjs.map
